// Dependencies
import { ModuleWithProviders }  from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// App Components
import { FaqPageComponent } from './pages/study-container-page/faq-page/faq-page.component';
import { OrganizationListPageComponent } from './pages/study-container-page/organization-list-page/organization-list-page.component';
import { PageNotFoundPageComponent } from './pages/page-not-found-page/page-not-found-page.component';
import { StudyContainerPageComponent } from './pages/study-container-page/study-container-page.component';
import { StudyLandingPageComponent } from './pages/study-container-page/study-landing-page/study-landing-page.component';
import { StudyPageComponent } from './pages/study-container-page/study-page/study-page.component';
import { SurveyGizmoPageComponent } from './pages/study-container-page/survey-gizmo-page/survey-gizmo-page.component';
import { ThankYouPageComponent } from './pages/thank-you-page/thank-you-page.component';

export const routes: Routes = [
    {
        path: '',
        component: PageNotFoundPageComponent,
        pathMatch: 'full'
    },
    {
        path: ':studySlug',
        component: StudyContainerPageComponent,
        children: [
            {
                path: '',
                component: StudyLandingPageComponent
            },
            {
                path: 'faqs',
                component: FaqPageComponent
            },
            {
                path: 'organizations',
                component: OrganizationListPageComponent
            },
            {
                path: 'start',
                component: StudyPageComponent
            },
            {
                path: 'survey-gizmo',
                component: SurveyGizmoPageComponent
            },
            {
                path: 'thank-you',
                component: ThankYouPageComponent
            },
        ]
    },
    {
        path: '**',
        redirectTo: '/',
        pathMatch: 'full'
    },
];

export const AppRoutes: ModuleWithProviders = RouterModule.forRoot(routes);


// WEBPACK FOOTER //
// ./src/app/app.routes.ts